import { EventEmitter, Input, Output } from '@angular/core';
import { IValidator } from 'src/app/_common/component/IValidator';
import { Address } from '../_common/data/input-data';
import { Code } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';

export class AddressComponent {

      public idPrefix:string = '';
      public streetNumberID:string = '';
      public streetNameID:string = '';
      public unitID:string = '';
      public buzzID:string = '';
      public cityID:string = '';
      public provinceID:string = '';
      public needSpecialDeliveryID:string = '';
      public deliveryModeID:string = '';
      public poboxID:string = '';
      public countryID:string = '';
      public otherCountryID:string = '';
      
      public  NotFound:any = Code.NotFound;
      public isCustodyOtherThanParent:boolean;

      public error_streetNumber:string = "";
      public error_streetName:string = "";
      public error_unit:string = "";
      public error_buzz:string = "";
      public error_city:string = "";
      public error_province:string = "";
      public error_postal:string = "";
      public error_poBox:string = "";
      public error_country:string = "";
      public error_otherCountry:string = "";

      protected validator:IValidator;

      @Input ('address') addr: Address;

      public validate() : boolean {
             return this.validator.validate();
      }

      public getPrefix() : string {
            return Math.random().toString(36).substr(2, 8) + '_';
      }

      public onStreetNumber() {

            setTimeout( () => {
                  this.addr.streetNumber = this.addr.streetNumber.trim();
                  if ( Util.isEmpty(this.addr.streetNumber) == false ) {
                  
                        let list = this.addr.streetNumber.split(' ');

                        if ( list.length > 1 ) {

                              let name = this.addr.streetNumber.substring(list[0].length+1).trim();
                              this.addr.streetNumber = list[0];

                              if ( Util.isEmpty(this.addr.streetName) ) {
                                   this.addr.streetName = name;
                              }
                        }
                  }
            },1);
     }
}

